<template>
	<StoryblokComponent v-if="story" :blok="story.content" />
</template>

<script lang="ts" setup>
	import type {PageTypeSummerLotteryStoryblok} from '~/storyblok/types';

	definePageMeta({title: 'Letní hra | Globus'});

	const fullSlug = '_globus-cz/letni-hra';
	const {data: story, error} = await useSingleStoryFetch<PageTypeSummerLotteryStoryblok>(fullSlug);

	if (!story.value || error.value) {
		await tryDynamicRedirectOrShowError(error);
	}

	useMetaTitle(`${story.value?.name} | Globus`);
</script>
